import React from "react";
import { BackgroundImage, HeaderComponent } from "../../FifthComponents";
import { Button, Form, Select, Input, DatePicker, Space } from 'antd';
import img from "../../fifthAssets/Images/appointment-img.jpg"
const { Option } = Select

const FifthAppointment = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const onFinish = async (values) => {
        let formData = new FormData()
        console.log('formData', values)
    }
    const handleChange = (value) => {
        console.log(`Selected: ${value}`);
    };
    return (
        <div>
            <BackgroundImage screenName={selectedLanguage?.txt_book_an_appointment} classForBg='fifth-des-news-bg' {...props}/>
            <HeaderComponent title={selectedLanguage?.txt_make_an_appointment} lineClass='bg-gray' titleClass='color-blue' />
            <div className="fifth-des-contact-div fifth-des-appointment-div">
                <div className="fifth-des-contact-img-div">
                    <img src={img} alt="" />
                </div>
                <div className="fifth-des-appointment-form-div">
                    <div>
                        <Form
                            labelCol={{ span: 24 }}
                            className='appointment-form'
                            name="basic"
                            onFinish={onFinish}
                        >
                            <div className='fifth-design-appoint-form-div'>
                                <div className="fifth-des-name-and-phone-div">
                                    <div>
                                        <Form.Item
                                            className="fifth-design-appointment-div"
                                            name='name'
                                        >
                                            <Input className="fifth-design-appointment-inputs  third-design-appointment-screen-inputs" placeholder={selectedLanguage?.txt_your_name} />
                                        </Form.Item>
                                    </div>
                                    <div>
                                        <Form.Item
                                            className="fifth-design-appointment-div"
                                            name='number'
                                        >
                                            <Input type="number" className="fifth-design-appointment-inputs  third-design-appointment-screen-inputs" placeholder={selectedLanguage?.txt_phone_number} />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div>
                                    <Form.Item
                                        className="fifth-design-appointment-div"
                                        name='email'
                                    >
                                        <Input className="fifth-design-appointment-inputs third-design-appointment-screen-inputs" placeholder={selectedLanguage?.txt_your_email} />
                                    </Form.Item>
                                </div>
                                <div>
                                    <Form.Item
                                        className="fifth-design-appointment-div"
                                        name='service'
                                    >
                                        <Select
                                            className="fifth-design-appointment-inputs third-design-appointment-select third-design-appointment-screen-inputs"
                                            showArrow
                                            showSearch
                                            allowClear
                                            placeholder={selectedLanguage?.txt_choose_clinic_for_appointment}
                                            optionFilterProp='children'
                                            filterOption={true}
                                            onChange={handleChange}
                                        >
                                            <Option value={'Alexandria'}>{selectedLanguage?.txt_alexandria}</Option>
                                            <Option value={'Cairo'}>{selectedLanguage?.txt_cairo}</Option>
                                        </Select>
                                    </Form.Item>
                                </div>
                                <div>
                                    <Form.Item
                                        className="fifth-design-appointment-div"
                                        name='message'
                                    >
                                        <Input.TextArea autoSize={{ minRows: 6 }} className="fifth-design-appointment-inputs third-design-appointment-screen-inputs" placeholder={selectedLanguage?.txt_health_question} />
                                    </Form.Item>
                                </div>
                                <div className='fifth-design-appointment-form-btn-div'>
                                    <Form.Item
                                        wrapperCol={{ span: 24, offset: 0 }}
                                    >
                                        <Button type="primary" htmlType="submit">
                                            {selectedLanguage?.txt_send}
                                        </Button>
                                    </Form.Item>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FifthAppointment